import { SelectChangeEvent, Stack, Box } from '@mui/material';
import { ImportedPayorderDto, CashflowDto, isCashflowDirectionAllowedForGroup } from '@sr/dto';
import { CashflowDirectionIcon, CashflowDirectionListIcon } from 'shared/ui/cashflow-chip';
import { GenericSelectPicker } from 'shared/ui/form-fields/generic-select-picker';
import { IRemoteCollection } from 'utils/remote-collection.hook';


export const CashflowCellContent = ({ importedPayorder, cashflowsDropDown, onChange, readonly = false }:
  {
    importedPayorder: ImportedPayorderDto,
    readonly?: boolean,
    cashflowsDropDown: IRemoteCollection<CashflowDto>,
    onChange: (newValue: number | null) => void;
  }) => {


  return (
    <GenericSelectPicker
      value={importedPayorder.importProps.selectedCashflowId || ''}
      onChange={(e: SelectChangeEvent) => !readonly && onChange(e.target.value === '' ? null : Number(e.target.value))}
      textFieldProps={{ size: 'small', disabled: readonly }}
      collection={cashflowsDropDown}
      isActive={(item) => !item.isDeleted}
      itemFilter={(item) => !importedPayorder.importProps.selectedGroup || isCashflowDirectionAllowedForGroup(item.direction, Number(importedPayorder.importProps.selectedGroup))}
      menuItemRender={cashflow => (
        <Stack direction="row" >
          <CashflowDirectionListIcon direction={cashflow.direction} />
          <Box>
            {cashflow.title}
          </Box>
        </Stack>)}
      selectedItemRender={cashflow => (
        <Stack direction="row" alignItems={'center'} justifyContent={'start'}>
          <CashflowDirectionIcon direction={cashflow.direction} />
          <Box ml={1} maxWidth={120} overflow={'hidden'}>
            {cashflow.title}
          </Box>
        </Stack>)}
    />
  );
};